import React from "react"
import PropTypes from "prop-types"

import Typograph from "components/Typograph"
import Button from "shared/components/Button/Button"

import styles from "./styles.css"

import SuccessIcon from "assets/svg/success-v2.svg"

function OrderStatus({ title, description, buttonText, onClose }) {
  return (
    <div>
      <div className={styles.header}>
        <img src={SuccessIcon} alt="Pedido recebido" />
        <Typograph htmlTag="h1" size="large" weight="bold" color="gunmetal">
          {title}
        </Typograph>
      </div>
      <Typograph htmlTag="p" size="medium" weight="medium" color="nevada_gray">
        {description}
      </Typograph>

      <div className={styles.button}>
        <Button buttonStyle="primary" width="small" onClick={onClose}>
          {buttonText}
        </Button>
      </div>
    </div>
  )
}

OrderStatus.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
  onClose: PropTypes.func
}
export default OrderStatus



// WEBPACK FOOTER //
// ./src/scenes/SharedEnergy/components/OrderStatus/index.js